// Module
var code = "<span ng-init=\"tit = row.phrases.join(', ')\" title=\"{{tit}}\">{{tit}}</span>";
// Exports
module.exports = code;